/** Endpoints #4-#9 — profiles list, bulk add, schedule, archive/restore, group membership. */
import { z } from 'zod';
import { SCHEDULE_MODES, } from '../enums.js';
import { BooleanParamSchema } from './common.js';
/** #4 `GET /api/profiles` */
export const ProfilesQuerySchema = z.object({
    includeArchived: BooleanParamSchema.optional(),
});
/** #5 `POST /api/profiles` — raw multi-URL text, one candidate per line. */
export const AddProfilesBodySchema = z.strictObject({
    input: z.string().min(1).max(50_000),
});
export const ADD_PROFILE_OUTCOMES = [
    'added',
    'invalid',
    'duplicate',
    /** Slug exists but is archived — powers the Restore offer (#8). */
    'archived_duplicate',
];
/** Note length cap. Declared here, not with the §10.4 URL limits below, because the #6 schema
    evaluates it at module load. */
export const PROFILE_NOTES_MAX_CHARS = 200;
/**
 * #6 `PATCH /api/profiles/:id` — the profile's editable fields, each optional; at least one
 * required. Deliberately no `.min(1)` on `notes`: unlike a group name, `''` is meaningful and
 * means "clear the note".
 */
export const UpdateProfileBodySchema = z
    .strictObject({
    scheduleMode: z.enum(SCHEDULE_MODES).optional(),
    /** Trimmed; the empty string clears the note. */
    notes: z.string().trim().max(PROFILE_NOTES_MAX_CHARS).optional(),
})
    .refine((body) => body.scheduleMode !== undefined || body.notes !== undefined, 'nothing to update');
/** #9 `PUT /api/profiles/:id/groups` — full replacement of the profile's memberships. */
export const SetProfileGroupsBodySchema = z.strictObject({
    groupIds: z.array(z.number().int().positive()).max(500),
});
/** Profile-URL normalization limits (§10.4). */
export const PROFILE_INPUT_MAX_CHARS = 300;
export const PROFILE_SLUG_MAX_CHARS = 100;
export const PROFILE_SLUG_PATTERN = /^[a-z0-9\-_%.]{1,100}$/;
//# sourceMappingURL=profiles.js.map